export default __webpack_public_path__ + "static/media/magic.7a02c087.jpg";